export const WALLET_LIST_STATUS = '/api/v1/wallet/asset/user/list';
export const USER_ASSETS = '/api/v1/accounting/statement/filter/brief/0/0';
export const GET_PRICES = '/api/v1/market/get-prices';
/**
 * Where the asset images are served from. Empty means this app's own host,
 * which is right wherever the API has the image files; the development
 * environment's API has none (every logo answers 404), so `.env.development`
 * points this at production, as the Android app does for every build.
 */
const IMAGE_HOST = import.meta.env.VITE_IMAGE_BASE_URL || '';
export const BASE_URL_FOR_IMAGE = `${IMAGE_HOST}/api/v1/wallet/static/img`;
